import { type CouponCodeQueryKey } from '@/features/authentication/services/SignupPromotions/queries'
import { type CouponCode } from '@/features/authentication/services/SignupPromotions/types'
import { apiGet } from '@/features/shared/utils/dataFetching'
import { type QueryFunctionContext } from '@tanstack/react-query'

export const fetchCouponCode = async (context: QueryFunctionContext<CouponCodeQueryKey>) => {
  const [, { gift_code }] = context.queryKey
  return apiGet<CouponCode>({
    config: {
      url: '/v1/codes/validate',
      params: {
        code: gift_code,
      },
    },
    context,
    options: {
      ignoredMessages: [
        'Please enter a valid membership code',
        'The membership code has been fully redeemed',
        'The membership code has expired',
      ],
    },
    fetcherName: 'fetchCouponCode',
  })
}
